<script lang="ts">
	import type { HelpPalletsProps } from "./HelpPalletsProps.js";
	import HelpPage from "../components/HelpPage.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import { setContext } from "svelte";
	import longParts from "../assets/images/long-parts.png";

	type $$Props = HelpPalletsProps;

	const { references, products, categories, blogPosts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, longParts);
</script>

<HelpPage
	heading="Chci skladovat dlouhé díly"
	perex="Naše konzolové regály jsou ideální pro skladování trubek, profilů nebo jiných dlouhých předmětů, a díky jejich flexibilní konstrukci snadno přizpůsobíme systém vašim potřebám. S našimi regály pro dlouhé díly optimalizujete skladový prostor a usnadníte manipulaci."
	{references}
	{products}
	{categories}
	{blogPosts}
>
	<p slot="subHeading">
		{nbspify("Pro")}
		<span class="text-primary">{nbspify("skladování dlouhých dílů")}</span>
		{nbspify(
			"nabízíme specializovaná řešení, která vám umožní bezpečně a efektivně manipulovat s rozměrnými materiály.",
		)}
	</p>
</HelpPage>
